// extracted by mini-css-extract-plugin
module.exports = {"appicon":"index_appicon__38WWA","empty":"index_empty__13uTI","loading":"index_loading__3Abpg","appiconWrap":"index_appiconWrap__13V0y"};